import React, {Component} from "react"
import {connect} from "react-redux"

import {FormattedMessage} from "@irati/utils/lang"
import tracking from "@irati-tracking/perks/perks"
import {H3, H4, H5} from "@irati/ui/src/Typography"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {ReduxState} from "@irati/store/types"
import MerchandiseSuccess from "@irati/ui/images/merchanside_checkout_success.png"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import authentication from "@irati/auth"
import productSettingsService from "@irati/permissions/services/productSettings"
import OnboardingService, {OnboardingStep} from "@irati/onboarding/services/onboarding"
import walletService from "@irati/wallet/graph/wallet"
import Flex from "@irati/ui/src/Flex"
import RouteConfig, {WELLNESS} from "@irati-web/app/src/routeConfig"

import {
  Banner,
  LeftBannerSection,
  RightBannerSection,
  FlexWrapper,
  BannerImage,
  StyledIcon} from "./styled"

interface Props {
  isMobile: boolean
}

interface State {
  monthlyTTAllowance: number,
  availableBalance: number,
  showBanner: boolean
}

class FlexiPointsBanner extends Component<Props, State> {
  state: State = {
    monthlyTTAllowance: 0,
    availableBalance: 0,
    showBanner: false
  }

  componentDidMount() {
    const business = authentication.business()
    OnboardingService.get(authentication.user().uuid).then((res) => {
      const hasSpentPoints = res.userProgress?.find(((item) => item.step === OnboardingStep.HAS_SPENT_ALL_FLEXI_POINTS))
      const hasSeenPointsBanner = res.userProgress?.find(((item) => item.step === OnboardingStep.HAS_SEEN_FLEXI_POINTS_BANNNER))

      if(!hasSpentPoints) {
        productSettingsService.get(business.uuid, business.rootTeamId).then(async(ps) => {
          const monthlyTTAllowance  = ps.perksSettings?.monthlyTTAllowance || 0
          const wallet = await walletService.get(authentication.user().uuid, "TT")
          const availableBalance = wallet?.availableBalance || 0

          if (monthlyTTAllowance > 0) {
            if (hasSeenPointsBanner && availableBalance === 0) {
              OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_SPENT_ALL_FLEXI_POINTS)
            } else if (availableBalance > 0) {
              OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_SEEN_FLEXI_POINTS_BANNNER)
              this.setState({showBanner: true, availableBalance, monthlyTTAllowance: monthlyTTAllowance / 100})
            }
          }
        })
      }
    })
  }


  handleWellnessClick = () => {
    tracking.clickBrowseLinkBanner("wellness")
  }

  handlePerksClick = () => {
    tracking.clickBrowseLinkBanner("perks")
  }

  render() {
    const {isMobile} = this.props
    const {showBanner, monthlyTTAllowance, availableBalance} = this.state

    if (!showBanner) {
      return null
    }

    const isWellnessHubActive = authentication.apps("wellnessHub")
    return (
      <Banner>
        <LeftBannerSection xs={12} md={7}>
          <FlexWrapper justifyContent="space-between">
            <div>
              {isMobile
                ? <Flex
                  height="100%"
                  direction="column"
                  alignItems="flex-start"
                  justifyContent="space-around"
                  marginRight={1}>
                  <H4 marginBottom="2.4rem">
                    <FormattedMessage id="perks.components.flexiPointsBanner.mobile.title1" />
                    <Icon icon={IconTypes.flexiPoints} size={24} marginLeft={.4} marginRight={.4} />
                    <FormattedMessage id="perks.components.flexiPointsBanner.mobile.title2" values={{points: availableBalance}} />
                  </H4>
                  <Flex gap="1rem" direction="column">
                    {isWellnessHubActive && <ButtonRouterLink
                      to="/"
                      app={RouteConfig[WELLNESS]}
                      full
                      small
                      onClick={this.handleWellnessClick}>
                      <FormattedMessage id="perks.components.flexiPointsBanner.browseWellness" />
                    </ButtonRouterLink>}
                    <ButtonRouterLink
                      primary
                      full
                      small
                      to="categories/flexi-perks"
                      onClick={this.handlePerksClick}>
                      <FormattedMessage id="perks.components.flexiPointsBanner.button" />
                    </ButtonRouterLink>
                  </Flex>
                </Flex>
                : <H3 marginRight={1}>
                  <Icon icon={IconTypes.flexiPoints} size={24} marginRight={.4} />
                  <FormattedMessage id="perks.components.flexiPointsBanner.left.title" values={{points: monthlyTTAllowance}} />
                </H3>
              }
            </div>
            <BannerImage src={MerchandiseSuccess} />
          </FlexWrapper>
        </LeftBannerSection>
        <RightBannerSection md={5} xsHidden smHidden>
          <H5 marginBottom={3}>
            <FormattedMessage id="perks.components.flexiPointsBanner.right.subtitle1" />
            <StyledIcon icon={IconTypes.flexiPoints} size={24} marginLeft={.4} marginRight={.4} />
            <FormattedMessage id="perks.components.flexiPointsBanner.right.subtitle2" values={{points: availableBalance}} />
          </H5>
          <Flex gap="1rem">
            {isWellnessHubActive && <ButtonRouterLink
              app={RouteConfig[WELLNESS]}
              small
              onClick={this.handleWellnessClick}
              to="/">
              <FormattedMessage id="perks.components.flexiPointsBanner.browseWellness" />
            </ButtonRouterLink>}
            <ButtonRouterLink
              primary
              small
              to="categories/flexi-perks"
              onClick={this.handlePerksClick}>
              <FormattedMessage id="perks.components.flexiPointsBanner.button" />
            </ButtonRouterLink>
          </Flex>
        </RightBannerSection>
      </Banner>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => ({isMobile: mq.lessThan.md})

export default connect(mapStateToProps)(FlexiPointsBanner)
